// extracted by mini-css-extract-plugin
export default {"modal":"UP-z","addItemButton":"VP-z","plusCircle":"WP-z","branchVisible":"XP-z"};